module.exports = __webpack_public_path__ + "img/h3xlogo.81121640.svg";